import { Container } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'
import CardsListContainer from './CardsList/CardsListContainer'

const useStyles = makeStyles(() => ({
    wrapper: { padding: '1rem' },
    h1: { textAlign: 'center' }
}))


const CardsPage = () => {
    const classes = useStyles()
    const { t } = useTranslation()

    return (
        <div className={classes.wrapper}>
            <Container>
                <br />
                <div>
                    <div className={classes.h1 + "  h2 f-400"}>{t('online-application-for-creating-plastic-card')}</div>
                </div>
                <br />
                <div>
                    <CardsListContainer />
                </div>

            </Container>
        </div>
    )
}


export default CardsPage